import { AffectedBy } from '@rivison-inc/ft-types';

export function formatDateAffectedBy(affectedBy: AffectedBy[] | undefined, hasTimeCondition: boolean): string | undefined {
  if (!hasTimeCondition || !affectedBy?.length) {
    return undefined;
  }

  return `Date affected by ${affectedBy.join(' & ')}`;
}
